// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.about-us{background-color:#061f35}body.about-us.noHeader:not(.fixedHeader) #mainHeader{background:transparent}body.about-us #classicHeader{display:none}body.about-us #mainFooter{margin-top:0;padding:0}body.about-us #mainFooter .container{padding-top:36px;max-width:949px}@media (min-width:1280px){body.about-us #mainFooter .container{padding-left:0;padding-right:0}}body.about-us #mainFooter picture{display:none}", ""]);
// Exports
module.exports = exports;
